import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { Question, Answer } from '@df/interfaces';
import { PupilService } from '@app/student/services/pupil.service';

@Component({
    selector: 'app-pupil-task-question',
    templateUrl: './pupil-task-question.component.html',
    styleUrls: ['./pupil-task-question.component.scss']
})
export class PupilTaskQuestionComponent implements OnInit {
    @Input() question: Question;
    @Input() questIndex: number;
    @Input() exercise;
    @Input() studentId: number;
    @Input() cardId: number;
    @Input() answer: Answer;
    answerString: string = '';
    buttons: any[] = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, '+', '-', '*', '/'];
    @Output() questionAnsweredCorrectly = new EventEmitter();
    @Output() questionAnswer = new EventEmitter();

    constructor(private pupilService: PupilService) {}

    ngOnInit(): void {
        if (this.answer) {
            this.answerString = this.answer.shortAnswer;
        }
    }

    clearAnswer(): void {
        this.answerString = '';
    }

    keyboardClicked(button: number): void {
        this.answerString = this.answerString + button.toString();
    }

    removeUnnecessaryInput(answer) {
        const reUnnecessary = /\(.*?\)/g;
        return answer.replace(reUnnecessary, '').trim();
    }

    updateAnswer(event) {
        this.answerString += event.target.value;
    }

    clickSpace(): void {
        this.answerString += ' ';
    }

    checkAnswer(): void {
        let isCorrect = false;
        let shortAnswer: string = null;
        let pupilAnswer = this.answerString;
        let numberFromCorrectAnswer;
        const answerStrictMode = this.exercise.answer_strict_mode;

        for (const answ of this.question.answers) {
            let correctAnswer = answ.shortAnswer;

            if (answerStrictMode) {
                correctAnswer = this.pupilService.pullNumber(correctAnswer);

                if (pupilAnswer === correctAnswer) {
                    isCorrect = true;
                    break;
                }

                numberFromCorrectAnswer = this.removeUnnecessaryInput(correctAnswer);

                if (correctAnswer !== pupilAnswer) {
                    pupilAnswer = this.removeUnnecessaryInput(pupilAnswer);
                }

                if (pupilAnswer === numberFromCorrectAnswer || pupilAnswer === answ.fullAnswer) {
                    isCorrect = true;
                    shortAnswer = correctAnswer;
                    break;
                }
            } else {
                const regex = /,| /;
                const modifAnswer = correctAnswer.split(', ');
                const studentAnswer = pupilAnswer.split(regex).filter(i => i);

                if (modifAnswer.length === studentAnswer.length) {
                    isCorrect = modifAnswer.every(i => studentAnswer.includes(i));
                    break;
                }
            }
        }

        if (shortAnswer === null) {
            shortAnswer = pupilAnswer;
        }

        const questionAnswer: Answer = {
            student: this.studentId,
            card: this.cardId,
            shortAnswer: shortAnswer,
            exercise: this.exercise.id,
            correct: isCorrect,
            question: this.question.id
        };

        this.questionAnswer.emit(questionAnswer);
        if (isCorrect) {
            this.questionAnsweredCorrectly.emit(true);
        } else {
            this.questionAnsweredCorrectly.emit(false);
        }
    }
}
